import { Icon, Layout, Menu } from 'antd';
import windowSizes from 'common/windowSizes';
import { schedulingCustomerOnly } from 'common/scheduling-access';
import 'components/admin/sidebar-nav/AdminSubMenu';
import AdminSubMenu from 'components/admin/sidebar-nav/AdminSubMenu';
import MCIcon from 'components/icon';
import { GlobalAppStateContext } from 'context/global-app-state';
import usePersistence from 'hooks/persistence';
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { withUserGroups } from '../userGroup';
import WithOrgData from '../WithOrgData';
import 'css/Navigation.less';
import useUserGroups from 'hooks/useUserGroups';
import {isTruey} from "../../common/util-ts";

const { Sider } = Layout;

const basePath = '/app/'

const mcItems = [
  {
    path: basePath + 'dashboard',
    key: 'dashboard',
    icon: 'play-circle',
    text: <span style={{
      lineHeight: '15px',
      position: 'relative',
      top: '-36px',
      left: '23px'
    }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span>Compliance</span>
        <span>Dashboard</span>
      </div>
    </span>
  },
  {
    path: basePath + 'scheduling',
    icon: 'calendar',
    text: 'Schedule',
    groups: ["flytsuite.schedule.sets", "flytsuite.schedule.flight", "flytsuite.schedule.passenger", "flytsuite.schedule.passenger.view"],
    onlyCustomer: schedulingCustomerOnly
  },
  {
    path: basePath + 'flights',
    icon: 'helicopter',
    text: 'Flights'
  },
  {
    path: basePath + 'passengers',
    icon: 'team',
    text: 'Passengers'
  },
  {
    path: basePath + 'cargo',
    icon: 'right-square',
    text: 'Cargo'
  },
  {
    path: basePath + 'tsacheck',
    icon: 'check',
    text: 'TSA Check',
    onlyTransporter: true
  },
  {
    path: basePath + 'flightTimes',
    icon: 'clock-circle',
    text: 'Flight Times',
    groups:["flytsuite.flight.times"]
  },
  {
      path: basePath + 'checkpoint',
      icon: 'check-circle',
      text: 'CheckPoint',
      groups: ['flytsuite.checkpoint.all']
  }
]

  const quartermasterItems = [
    {
      path: basePath + 'quartermaster',
      icon: 'rig',
      text: 'Quartermaster',
      className: 'mc-navigation-item-quartermaster',
      groups:["flytsuite.quartermaster"],
      onlyCustomer: true
    }
  ];
  const flytwatchItems = [
    {
      path: basePath + 'flytwatch',
      text: 'Home',
      groups: ['flytsuite.flytwatch.view'],
      evalPathsFirst: [
        basePath + 'flytwatch/history',
        basePath + 'flytwatch/historical-reporting',
        basePath + 'flytwatch/fuel-taken'
      ]
    },
    {
      path: basePath + 'flytwatch/history',
      rootPath: basePath + 'flytwatch',
      text: 'Approve Flights',
      groups: ['flytsuite.flytwatch.history.read']
    },
    {
      path: basePath + 'flytwatch/historical-reporting',
      rootPath: basePath + 'flytwatch',
      text: 'Historical Reporting',
      groups: ['flytsuite.flytwatch.history.read']
    },
    {
      path: basePath + 'flytwatch/fuel-taken',
      rootPath: basePath + 'flytwatch',
      text: 'Fuel Taken',
      onlyTransporter: true,
      groups: ['flytsuite.flytwatch.view']
    }
  ]
  const reportItems = [
    {
      path: basePath + 'report/covid',
      text: 'Covid'
    },
    {
      path: basePath + 'report/manifest',
      text: 'Manifest'
    },
    {
      path: basePath + 'report/passenger',
      text: 'Passenger'
    },
    {
      path: basePath + 'report/vaccinated-passengers',
      text: 'Vaccinated Pax',
      groups: ['flytsuite.covid19vaxrecords.read']
    },
    {
      path: basePath + 'report/personnel-vax-details',
      text: 'Personnel Vax Details',
      groups: ['flytsuite.covid19vaxrecords.read'],
      onlyCustomer: true
    },
    {
      path: basePath + 'report/cargo',
      text: 'Cargo'
    },
    {
      path: basePath + 'report/isn',
      text: 'ISN'
    },
    {
      path: basePath + 'report/hotfuel',
      text: 'Hot Fuel',
      groups: ['flytsuite.report.hotfuel.all']
    },
    {
      path: basePath + 'report/pax-isn-events',
      text: 'Pax ISN Events',

      // TODO: Does this need its own user groups?
      groups: ['flytsuite.master.all', 'flytsuite.management.all', 'flytsuite.management.emailtriggers.all']
    }
  ]
  
  const mdItems = [
    {
      path: basePath + 'masterdata/whitelist',
      text: 'ISN White List',
      onlyCustomer: true
    },
    {
      path: basePath + 'masterdata/nonpreferred',
      text: 'Non-Preferred List',
      onlyCustomer: true
    },
    {
      path: basePath + 'masterdata/aircraft',
      text: 'Aircraft',
      onlyTransporter: true,
      groups: ['flytsuite.master.all', 'flytsuite.master.edit', 'flytsuite.master.delete']
    },
    {
      path: basePath + 'masterdata/contract',
      text: 'Contracts',
      onlyTransporter: true,
      groups: ['flytsuite.master.all', 'flytsuite.master.edit', 'flytsuite.master.delete']
    },
    {
      path: basePath + 'masterdata/customer',
      text: 'Customers',
      onlyTransporter: true,
      groups: ['flytsuite.master.all', 'flytsuite.master.edit', 'flytsuite.master.delete']
    },
    {
      path: basePath + 'masterdata/employer',
      text: 'Employers',
      groups: ['flytsuite.master.all', 'flytsuite.master.edit', 'flytsuite.master.delete']
    },
    {
      path: basePath + 'masterdata/location',
      text: 'Locations',
      onlyTransporter: true,
      groups: ['flytsuite.master.all', 'flytsuite.master.edit', 'flytsuite.master.delete']
    },
    {
      path: basePath + 'masterdata/pilot',
      text: 'Pilots',
      onlyTransporter: true,
      groups: ['flytsuite.master.all', 'flytsuite.master.edit', 'flytsuite.master.delete']
    },
    {
      path: basePath + 'masterdata/personnel',
      text: 'Personnel',
      groups: [
        'flytsuite.master.all',
        'flytsuite.master.edit',
        'flytsuite.master.delete',
        'flytsuite.master.person.all', 'flytsuite.master.person.edit', 'flytsuite.master.person.delete'
      ]
    },
  ]

  const managementItems = [
    {
      path: basePath + 'management/email-triggers',
      rootPath: basePath + 'management',
      text: 'Email Triggers',
      onlyCustomer: true,
      groups: ['flytsuite.master.all', 'flytsuite.management.all', 'flytsuite.management.emailtriggers.all']
    }
  ]

  const veriflytItems = [
    {
      path: basePath + 'veriflyt/records',
      rootPath: basePath + 'veriflyt',
      text: 'Records',
      onlyCustomer: true,
      groups: ['flytsuite.compliance.ticket.all']
    },
    {
      path: basePath + 'veriflyt/rules',
      rootPath: basePath + 'veriflyt',
      text: 'Rules',
      onlyCustomer: true,
      groups: ['flytsuite.compliance.rule.all']
    }
  ]

  const adminItems = [
    {
      path: basePath + 'admin/user'
    },
    {
      path: basePath + 'admin/fw-billing-report'
    },
    {
      path: basePath + 'admin/fw-changes-by-console'
    }
  ]

const FlightsNav = (props) => {
    const { state: { sidebarCollapsed }, setState } = useContext(GlobalAppStateContext);
    const { persistentData, setPersistentValues } = usePersistence('mc.flights.sidenav');
    const [ userGroups ] = useUserGroups();

    const { customer } = props.orgData;
    const { pathname } = props.location;
    const renderMenuItems = (data) => (
        data.map(item => {
            var authorized = false;
            if (item.groups){
              item.groups && item.groups.forEach(group => {
                if (props.userGroups.includes(group)){
                  authorized = true;
                }
            })
            }else{
              authorized = true;
            }
            if ( item.onlyCustomer && !customer){
              authorized = false
            }
            if ( item.onlyTransporter  && customer){
              authorized = false
            }
            if (authorized === true){
              return (
                <Menu.Item key={item.path}
                  className={item.className}
                  onClick={() => {
                    props.history.push(item.path);
                    if (window.innerWidth <= windowSizes.small){
                      setState({ sidebarCollapsed: true })
                    }
                  }}>
                  {item.icon && <MCIcon type={item.icon} />}
                  <span>{item.text}</span>
                </Menu.Item>
              )
            }
            return null
          }
        )
            .filter(isTruey)
    )
    const allMenuItemsPaths = [
      ...mcItems,
      ...quartermasterItems,
      ...flytwatchItems,
      ...reportItems,
      ...mdItems,
      ...managementItems,
      ...veriflytItems,
      ...adminItems,
    ];

    const isAuthorized = (item) => {
      let authorized = false;
      if (item.groups) {
        item.groups.forEach(group => {
          if (props.userGroups.includes(group)) authorized = true;
        });
      } else {
        authorized = true;
      }
      if (item.onlyCustomer && !customer) authorized = false;
      if (item.onlyTransporter && customer) authorized = false;
      return authorized;
    };

    const normalizePath = (p) => (p || '').split('?')[0].split('#')[0].replace(/\/+$/, '');

    const pathMatches = (itemPath, currentPath) => {
      const a = normalizePath(itemPath);
      const b = normalizePath(currentPath);
      if (!a) return false;
      return b === a || b.startsWith(a + '/');
    };

    const visibleItems = allMenuItemsPaths.filter(isAuthorized);

    const bestMatch = visibleItems
      .filter(it => pathMatches(it.path, pathname))
      .sort((a, b) => b.path.length - a.path.length)[0];

    // Fallback: if no direct match, try matching by rootPath (e.g., /app/veriflyt)
    const bestRootMatch = !bestMatch ? visibleItems
      .filter(it => it.rootPath && pathMatches(it.rootPath, pathname))
      .sort((a, b) => (b.rootPath || '').length - (a.rootPath || '').length)[0] : null;

    const matchingPath = bestMatch ? bestMatch.path : (bestRootMatch ? bestRootMatch.path : '');

    // Restore expanded sections separately from the closed popup menus used when collapsed.
    const menu = <Menu
        key={sidebarCollapsed ? 'collapsed' : 'expanded'}
        mode="inline"
        selectedKeys={[matchingPath]}
        defaultOpenKeys={sidebarCollapsed ? [] : persistentData.openKeys || [
          'manifesting', 'reporting', 'flytwatch', 'masterData', 'management', 'veriflyt', 'admin'
        ]}
        onOpenChange={(openKeys) => {
          if (!sidebarCollapsed) {
            setPersistentValues({ openKeys });
          }
        }}
        style={{ height: '100%', borderRight: 0 }}
        theme="dark"
    >
      <Menu.SubMenu className='mc-navigation-submenu-manifesting' key="manifesting" title={<span><Icon type="global" /><span>Manifesting</span></span>}>
        {renderMenuItems(mcItems)}
      </Menu.SubMenu>
      {renderMenuItems(quartermasterItems)}
      { props.userGroups.includes('flytsuite.flytwatch.view') ? 
        (<Menu.SubMenu className='mc-navigation-submenu-flytwatch' key="flytwatch" title={<span><MCIcon type="flytwatch" /><span>FlytWatch</span></span>}>
          {renderMenuItems(flytwatchItems)}
        </Menu.SubMenu>) : null
      }
      <Menu.SubMenu className='mc-navigation-submenu-report' key="reporting" title={<span><Icon type="file-text" /><span>Report</span></span>}>
          {renderMenuItems(reportItems)}
      </Menu.SubMenu>
      <Menu.SubMenu className='mc-navigation-submenu-masterdata' key="masterData" title={<span><Icon type="database" /><span>Master Data</span></span>}>
          {renderMenuItems(mdItems)}
      </Menu.SubMenu>
      {managementItems.length ?
        <Menu.SubMenu className='mc-navigation-submenu-management' key="management" title={<span><Icon type="team" /><span>Management</span></span>}>
            {renderMenuItems(managementItems)}
        </Menu.SubMenu> : null
      }
      {renderMenuItems(veriflytItems).length ?
          <Menu.SubMenu className='mc-navigation-submenu-veriflyt' key="veriflyt" title={<span><Icon type="check" /><span>VeriFlyt</span></span>}>
            {renderMenuItems(veriflytItems)}
          </Menu.SubMenu> : null
      }
      <AdminSubMenu key="admin" />
    </Menu>

    return (
        <Sider className='mc-navigation' width={200} style={{ overflowY: 'auto', overflowX: 'hidden', height: '100%'}} collapsed={sidebarCollapsed} breakpoint="lg">
            {menu}
        </Sider>
    )
}

export default WithOrgData( withUserGroups( withRouter( FlightsNav ) ) )
